module.exports = __webpack_public_path__ + "media/images/icons/icon-ted-b1e743966c62f09d818d2cbe9163f700.svg";